<!--
 * @FileDescription: 文字介绍轮播组件
 * @Author: 作者信息
 * @Date: 文件创建时间
 * @LastEditors: dcq
 * @LastEditTime: 2023-07-26 12:53:48
 -->
 <template>
    <DvBorderBox8 class="desc-template" :order="order" :keyValId="keyValId">
      
      <div class="desc-container">
        <el-carousel height="100%" class="desc-carousel" ref="descCarousel" indicator-position="none" :autoplay="false">
          <el-carousel-item v-for="item in descInfo3" :key="item.properties.name">
            <div class="desc-box">
              <div class="desc-title">{{ item.properties.name }}</div>
              <div class="desc-content">{{ item.properties.desc }}</div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </DvBorderBox8>
  </template>
  
  <script>
  export default {
    name: 'DescribeTemplate',
  }
  </script>
  
  <script setup>
  import { defineProps, watch, ref ,onMounted} from 'vue';
  import { BorderBox8 as DvBorderBox8 } from '@kjgl77/datav-vue3';
  import axios from 'axios';
  // import { locatSearchData} from './schoolData';
  // import activeJson from "@/components/activeChartData.json"

  let props = defineProps({
    order: String,
    searchSciIndex: Number,
    keyValId: String,
  });
  console.log('desc props', props.searchSciIndex)
  
  let descCarousel = ref();
  let activeJson=ref({})
  let descInfo3 = ref([])

  onMounted(() => {
    axios.get('/activeChartData.json')
      .then(response => {
        activeJson.value= response.data;
        descInfo3.value=activeJson.value.searchSciPt.features
        // searchInformation.value[0]={ name: '园区', val: searchNum.value + '所' }
      })
      .catch(error => {
        console.log(error);
      });
  }),
  
  // const order = props.order;
  
//   const descInfo1 = schoolData;
  // const descInfo2 = locatSearchData;
  // const descInfo3 = activeJson.searchSciPt.features;
  
  // onMounted(() => {
  //   descCarousel.value.setActiveItem(props.schoolIndex - 1);
  // })
  
  watch(props, (newProps) => {
    descCarousel.value.setActiveItem(newProps.searchSciIndex - 1);
  })
  
  </script>
  
  
  <style lang="scss" scoped>
  $orders: 1, 2, 3, 4, 5, 6, 7, 8;
  
  div.desc-template {
    &[keyValId='2'] {
      position: absolute;
        // margin-top: 1vh;
      right: 1vw;
      margin-bottom: 1vh;
      width: 42vw;
      height: 41vh;
    }
  
    &[keyValId='3'] {
      position: absolute;
      // margin-top: 4vh;
      // margin-bottom: 1vh;
      top: 42vh;
      right: 1vw;
      width: 32vw;
      height: 36vh;
      z-index: 12;
    }
  
    @each $order in $orders {
      &[order='#{$order}'] {
        order: $order;
      }
    }
  
    div.border-box-content {
      width: 42vw;
      height: 41vh;
      border-radius: 10px;
  
      div.desc-container {
        position: absolute;
        top: 0.5%;
        left: 0.5%;
        width: 99%;
        height: 99%;
        z-index: 10;
        // border-radius: 8px;
        overflow: hidden;
        background-color: rgba(255, 255, 255, 0.15);
        backdrop-filter: blur(4px);
  
        .desc-carousel {
          width: 100%;
          height: 100%;
  
          .el-carousel__container {
            width: 100%;
            height: 100%;
  
            .desc-box {
              height: 100%;
              width: 100%;
              display: flex;
              flex-flow: column nowrap;
              align-items: center;
              justify-content: center;
              // row-gap: 5%;
  
              div.desc-title {
                // margin-top: 4%;
                width: fit-content;
                height: 6vh;
                line-height: 6vh;
                vertical-align: middle;
                background-image: linear-gradient(25deg,
                    #DAFDBA 0%,
                    #9AEBA3 40%,
                    #45C4B0 100%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                -webkit-animation: hue 60s infinite linear;
                word-wrap: break-word;
                font-size: calc(0.6vh + 1.1vw);
                font-weight: 600;
                text-align: center;
                font-family: "Microsoft YaHei";
              }
  
              div.desc-content {
                padding-left: 3%;
                padding-right: 3%;
                background-image: linear-gradient(15deg,
                    #fafff6 0%,
                    #ebffd9 70%,
                    #bcffc4 100%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                -webkit-animation: hue 60s infinite linear;
                font-size: calc(1vh + 0.4vw);
                margin-bottom: 5%;
              }
            }
          }
        }
      }
  
    }
  }
  </style>
  